import axios from 'axios'
import * as _ from 'lodash';

export default {
    state: {
        replies: []
    },
    mutations: {
        fetchReplies(state, payload) {
            state.replies = payload
        },
        addReplyToList(state, payload) {
            let posts = this.state.posts.posts;
            Object.keys(posts).forEach(key => {
                if (posts[key].id === payload.new_id) {
                    // fix to prevent duble insert(from http and Socket.io), check is reply already inserted (by this application instance)
                    let reply = _.find(posts[key].replies, p => p.id == payload.id);
                    if (reply) {
                        return; // exit
                        //? or pass to update
                    }

                    if (!posts[key].replies) {
                        posts[key].replies = [];
                    }

                    posts[key].replies.push(payload);
                }
            })
        },
    },
    actions: {
        async fetchReplies({ commit }) {
            commit('clearError')
            commit('setLoading', true)
            try{
                commit ('fetchReplies', [])
                commit('setLoading', false)
            }catch(error){
                commit('setLoading', false)
                commit('setError', error.message)
                throw error
            }
        },
        async createNewReply({commit, dispatch}, payload){
            commit('clearError')
            commit('setLoading', true)

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.post(`${this._vm.appConfig.app_url}/api/reply`, payload, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('addReplyToList', data)
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },
    },
    getters: {
        replies (state) {
            return state.replies
        },
    }

}